import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../styles/const/colors'

const useStyles = createUseStyles({
  container: {
    marginTop: 16,
    background: 'white',
    border: {
      width: 1,
      style: 'solid',
      color: lightGrey
    },
    borderRadius: 7
  }
})

export default useStyles
